export default "__VITE_ASSET__jR0FY_hX__"